import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
    selector: 'app-incorrect-country-dialog',
    templateUrl: './incorrect-country-dialog.html',
})
export class IncorrectCountryDialogComponent {

    public mainForm: FormGroup;
    public captchaUrl: string;

    constructor(
        public dialogRef: MatDialogRef<IncorrectCountryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder) {

    }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/incorrect-country-dialog/incorrect-country-dialog.ts